import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { SIGNUP_URL } from "../lib/config";
import { trackSignupCta } from "../lib/analytics";

export default function PricingPill({
  variant = "pricing",
}: {
  variant?: "pricing" | "signup";
}) {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 240);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/pricing")) return null;

  const wrap = `fixed top-20 left-1/2 -translate-x-1/2 z-40 transition-all duration-300 ${
    visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-3 pointer-events-none"
  }`;

  if (variant === "signup") {
    return (
      <div className={wrap}>
        <div className="flex items-center gap-1 bg-white/95 backdrop-blur border border-gray-200 shadow-lg rounded-full p-1 text-sm">
          <a
            href={SIGNUP_URL}
            onClick={() => { if (pathname === "/") trackSignupCta("floating"); }}
            tabIndex={visible ? 0 : -1}
            className="rounded-full bg-brand-500 hover:bg-brand-600 text-white font-semibold px-4 py-2 transition-colors whitespace-nowrap"
          >
            Create my free briefing →
          </a>
          <Link
            to="/pricing/"
            tabIndex={visible ? 0 : -1}
            className="rounded-full px-3 py-2 text-gray-600 hover:text-brand-600 transition-colors whitespace-nowrap"
          >
            Pricing
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`fixed top-20 left-1/2 -translate-x-1/2 z-40 transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 -translate-y-3 pointer-events-none"
      }`}
    >
      <Link
        to="/pricing/"
        aria-label="See pricing"
        className="flex items-center gap-2 bg-white/95 backdrop-blur border border-gray-200 shadow-lg rounded-full pl-5 pr-4 py-2.5 text-sm font-semibold text-gray-900 hover:shadow-xl hover:border-brand-300 transition-all"
      >
        <span>See pricing</span>
        <span className="text-brand-500">→</span>
      </Link>
    </div>
  );
}
